<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Permohonan Semen IBVK">
      <div class="table_scrol">
        <div class="w-card__content content-hardcode mb3">
        <w-form v-model="valid" @validate="cari" ref="frm">
          <w-flex class="mt2">
            <div class="xs6">
              <w-input style="margin:5px; "
                v-model="pencarian.no_permohonan"
                label="No. Permohonan"
              />
            </div>
            <div class="xs6">
              <w-input style="margin:5px; "
                v-model="pencarian.name"
                label="Nama Pemohon"
              />
            </div>
            <div class="xs6">
              <z-select style="margin:5px; "
               v-model="pencarian.status"
               :items="[
                 { value: 16, label: 'Mohon' },
                 { value: 21, label: 'Ditolak' },
                 { value: 22, label: 'Lulus' },
               ]"
               label="Status"
               />
            </div>
          </w-flex>
        </w-form>

        <w-flex justify-end class="mt2">
                      <w-button bg-color="success" v-on="on" @click="cetak()" class="mr2">
                    <w-icon class="mr1" md >fal fa-print</w-icon>CETAK
                </w-button>
                      <w-button class="mr2" v-on:click="resetPencarian()" v-on="on" bg-color="warning">
                    <w-icon class="mr1" md >fal fa-redo</w-icon>SET SEMULA
                </w-button>
                      <w-button class="mr2" bg-color="primary"  v-on="on" @click="$refs.frm.validate()">
                    <w-icon class="mr1" md >fal fa-search</w-icon>CARI
                </w-button>
        </w-flex>
      </div>
		  <z-table title="Senarai Permohonan IBVK" :headers="table.headers" :items="table.items" :meta="table.meta">
		    <template #header-label="{ header, label, index }">
		      <template v-if="header.key == 'action'">
           TINDAKAN
          </template>
		      <template v-else>
		      	{{ label }}
		      </template>
		    </template>
		    <template #item-cell.action="{ item, label, header, index }">
		      <w-flex class="flex justify-center">
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button @click="papar(item)" v-on="on" v-if="item.lkp_status_id==22||item.lkp_status_id ==21" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-eye</w-icon>
                </w-button>
                </template>
               PAPAR
            </w-tooltip>
          &nbsp;
          <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button bg-color="warning" v-on="on" v-if="item.lkp_status_id==16&&$zutil.anyRole(['1', '3'])" :route="$route('se.permohonan.ibvk.form',item.id)" class="be fs-2"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-pencil</w-icon>
                </w-button>
                </template>
               KEMASKINI
            </w-tooltip>
                    &nbsp;
            <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button class="fs-2" v-on="on" v-if="item.lkp_status_id==16&&$zutil.anyRole(['1', '3'])" bg-color="error-dark1" dark tile @click="tolak(item)"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-trash</w-icon>
                </w-button>
                </template>
               TOLAK
            </w-tooltip>
          </w-flex>
		    </template>
        <template #item-cell.tarikh="{ item, label, header, index }">
          <w-flex class="flex justify-light">
            {{ $zutil.dateformat(item.tarikh)}}
          </w-flex>
        </template>
        <template #item-cell.tarikh_daftar="{ item, label, header, index }">
          <w-flex class="flex justify-light">
            <template v-if="item.tarikh_daftar!=''">
            {{ $zutil.dateformat(item.tarikh_daftar)}}
            </template>
            <template v-else>
              -
            </template>
          </w-flex>
        </template>
		  </z-table>
      </div>
	  </z-page>
      <w-dialog
        v-model="dialog.show"
        :fullscreen="dialog.fullscreen"
        width="1200"
        :persistent="dialog.persistent"
        :persistent-no-animation="dialog.persistentNoAnimation"
        title-class="primary-dark1--bg white">
        <template #title>
          <w-icon class="mr2">fal fa-cog</w-icon>
          Detail
        </template>
          <table >
            <tbody>
              <tr class="row_data">
                <td><b>Tarikh</b></td>
                <td><b>:</b></td>
                <td>{{ $zutil.dateformat(form.tarikh)}}</td>
              </tr>
              <tr class="row_data">
                <td><b>Nama</b></td>
                <td><b>:</b></td>
                <td>{{form.nama}}</td>
              </tr>
              <tr class="row_data">
                <td><b>Negeri Mohon</b></td>
                <td><b> : </b></td>
                <td>{{form.lkpNegeri_label}}</td>
              </tr>
            </tbody>
          </table><br>
          <div class="table-responsive">
          <table class="w-table fixed-headers" style="height: 250px" valign="top">
            <thead>
              <tr>
                <th class="w-table__header w-table__header--sortable text-center" width="1px">Bil</th>
                <th class="w-table__header w-table__header--sortable text-center">Kuantiti Dimohon</th>
                <th class="w-table__header w-table__header--sortable text-center">Jenis Ternakan</th>
                <th class="w-table__header w-table__header--sortable text-center">Jurusan</th>
                <th class="w-table__header w-table__header--sortable text-center">Baka Ternakan</th>
                <th class="w-table__header w-table__header--sortable text-center">Tujuan/Justifikasi/Catatan</th>
                <th class="w-table__header w-table__header--sortable text-center">Batch Nombor</th>
                <th class="w-table__header w-table__header--sortable text-center">Kuantiti Diluluskan</th>
                <th class="w-table__header w-table__header--sortable text-center">Tindakan <br>(Lulus/Gagal)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(dt, index) in form.butiran" :key="index" valign="top">
                <td class="w-table__cell text-center" width="1px">
                  {{index+1}}
                </td>
                <td class="w-table__cell text-center">
                  {{dt.kuantiti}}
                </td>
                <td class="w-table__cell text-left">
                  {{dt.label_ternakan}}
                </td>
                <td class="w-table__cell text-left">
                  {{dt.label_jurusan}}
                </td>
                <td class="w-table__cell text-left">
                  {{dt.label_baka}}
                </td>
                <td class="w-table__cell text-left">
                  {{dt.catatan}}
                </td>
                <td class="w-table__cell text-left">
                  <div v-for="stock in dt.stock" >
                    {{stock.no_batch}}
                  </div>
                </td>
                <td class="w-table__cell text-right">
                  <div v-for="stock in dt.stock" >
                    {{stock.kuantiti}}
                  </div>
                </td>
                <td class="w-table__cell text-center">
                  {{dt.lkpStatus_label}}
                </td>
              </tr>
              <tr>
                  <td class="w-table__cell text-center" width="1px"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-left">Jumlah Diluluskan</td>
                  <td class="w-table__cell text-right">{{form.kuantiti_lulus}}</td>
                  <td class="w-table__cell text-center"></td>
              </tr>
              <tr>
                  <td class="w-table__cell text-center" width="1px"></td>
                  <td class="w-table__cell text-left"></td>
                  <td class="w-table__cell text-right"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-left">Jumlah Tidak Lulus</td>
                  <td class="w-table__cell text-right">{{form.kuantiti_tidak_lulus}}</td>
                  <td class="w-table__cell text-center"></td>
              </tr>
            <template v-if="form.lkp_status_id == 22"> 
            <tr class="row_data">
               <td><b>Catatan</b></td>
               <td><b>:</b></td>
               <td>{{ form.catatan }}</td>
            </tr>
         </template>
         <template v-if="form.lkp_status_id == 21"> 
            <tr class="row_data">
               <td><b>Catatan</b></td>
               <td><b>:</b></td>
               <td>{{ form.catatan_tindakan }}</td>
            </tr>
         </template>
            </tbody>
          </table>
          </div>
          <template #actions>
            <div class="spacer" />
            <w-button 
              style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " 
              @click="dialog.show = false">
              TUTUP
            </w-button>
          </template>
      </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.permohonan.ibvk',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Permohonan', route: '/se/permohonan' },
        { label: 'Semenn IBVK', route: '/se/permohonan/ibvk' },
      ],
      pencarian: {
         no_permohonan: '',
         name: '',
         status: ''
      },
      se_katalog: [],
      form:[],
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 900,
        item: {}
      },
      
    }
  },
  methods: {
    cetak() {
      window.location.href = window.route('se.permohonan.ibvk.index')+'?no_permohonan='+this.pencarian.no_permohonan+'&name='+this.pencarian.name+'&status='+this.pencarian.status+'&cetak=1';
    },
    papar(items){
      this.getData(items)
      this.dialog.show = true
    },
    getData(items){
      if(items.id > 0){
        this.$zcomm.get(this.api_service + 'permohonan/show/'+items.id, {}).then(res => {
          this.form = res

        })
      }
    },
    cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },
    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },
    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/id_ternakan', {}).then(res => {
        this.se_katalog = res
      })
    },
    destroy1(id)
    {
      this.$swal({
        title: 'Anda Pasti?',
        // text: "Are you sure want to delete this item!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy',id)
          .then(res => {
            this.sending = false;
            this.$inertia.visit(this.$page.url)
            this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
              this.onAfterDelete()
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })

    },
    tolak(item){
      this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if (item.id > 0) 
          {
            item.hantar = 3;
            this.$zcomm.update(this.resourceurl + '.update', item.id, item)
            .then(res => {
              if (typeof this.onAfterEdit === "function") {
                this.onAfterEdit()
              }
              this.$zutil.notify("Berjaya dihantar", true);
              this.$inertia.visit(this.$route('se.permohonan.ibvk.index'))
            })
          }
        }else{ }
        })
      },
  
  },

  watch: {

  },
  mounted() {
    // this.getKatalog();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
